import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    data: [],
    filters: {
        locationid: '',
        startdate: null,
        enddate: null,
        worktypeid: null,
        companyid: null,
        userid: null,
    },
    error: '',
};

export const fetchOperationsActivityTimeReport = createAsyncThunk(
    'operationsActivityTimeReport/fetchOperationsActivityTimeReport',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/workingmapworkers/activitytimereport`, {
                params,
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const operationsActivityTimeReportSlice = createSlice({
    name: 'operationsActivityTimeReportSlice',
    initialState,
    reducers: {
        setFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
                locationid: '',
                worktypeid: null,
                companyid: null,
                userid: null,
            };
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchOperationsActivityTimeReport.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchOperationsActivityTimeReport.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.data = payload.data;
        });
        builder.addCase(fetchOperationsActivityTimeReport.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
    },
});

export const { setFilters, resetFilters } = operationsActivityTimeReportSlice.actions;

export default operationsActivityTimeReportSlice.reducer;

export const selectOperationsActivityTimeReportFilters = (state) => state.operationsActivityTimeReport.filters;
export const selectOperationsActivityTimeReportData = (state) => state.operationsActivityTimeReport.data;
export const selectOperationsActivityTimeReportLoading = (state) => state.operationsActivityTimeReport.isLoading;
export const selectOperationsActivityTimeReportError = (state) => state.operationsActivityTimeReport.error;
